<template>
  <div class="box">
    <!-- ****************** -->
    <!-- DISPLAY CATEGORIES -->
    <!-- ****************** -->
    <h3 class="sub_tit">{{ $t('library.bookcategorybox.4739') }}</h3>
    <div v-if="!editCategories && mode !== 'create'" class="box_inner">
      <p v-for="(category, idx) in categories" :key="idx" class="meta_itemlege">
        <span>
          {{ category.parent.title }} <span class="svg_next">></span>
          {{ category.child.title }}
          <span class="svg_next">></span>
          <!-- TODO: @stan Need to fix sub2 -->
          {{ category.sub2 }}</span
        >
      </p>
    </div>
    <!-- selfbook edit btn -->
    <div v-if="!editCategories && mode !== 'create'" class="btn_wrap atr">
      <a class="an_a" @click="toggleEditCategories"
        ><span class="c_icon ico_edit_sbook"></span
        ><span class="an_t">{{ $t('library.bookcategorybox.5234') }}</span></a
      >
    </div>

    <!-- ********************************** -->
    <!-- STAGED DROPDOWN CATEGORY SELECTION -->
    <!-- ********************************** -->
    <!-- Main Category Selection -->
    <div v-if="mode === 'create'" class="editer_form_wrap">
      <div class="editer_form">
        <div
          v-for="(cat, index) in categories"
          :key="index"
          class="row college_group"
        >
          <BookCategoryRow :category="cat" />
          <button
            type="button"
            class="btn_delete_college an_a"
            @click="deleteCategoryRow(index)"
          >
            <span class="c_icon"></span><span class="an_t">삭제</span>
          </button>
        </div>
        <button class="btn_insert_college an_a" @click="addCategoryRow">
          <span class="an_t">{{ $t('library.bookcategorybox.8435') }}</span>
        </button>
      </div>
      <div v-if="$route.path !== '/selfbook/create'" class="btn_wrap ar">
        <div>
          <button class="box_btn dull" @click="toggleEditCategories">
            <span class="an_t">{{ $t('library.deletemodal.cancel') }}</span>
          </button>
        </div>
        <div>
          <button class="box_btn" @click="saveCategoryChanges">
            <span class="an_t">{{ $t('library.deletemodal.save') }}</span>
          </button>
        </div>
      </div>
    </div>
    <!-- End Edit Box -->
  </div>
</template>

<script>
import BookCategoryRow from '@/components/library/BookCategoryRow.vue'

import { STORE_CATEGORIES_GET_ALL } from '@/store/types'

import { mapGetters } from 'vuex'

export default {
  name: 'BookCategoryBox',
  components: {
    BookCategoryRow
  },
  props: {
    categories: {
      type: Array,
      default: null
    },
    /* possible values: ['create', 'edit', 'view'] */
    mode: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      editCategories: false
    }
  },
  computed: {
    ...mapGetters(['getMainAllCategories'])
  },
  mounted() {
    if (!this.getMainAllCategories) {
      this.$store.dispatch(STORE_CATEGORIES_GET_ALL)
    }
  },
  methods: {
    toggleEditCategories() {
      this.editCategories = !this.editCategories
    },
    deleteCategoryRow(index) {
      this.categories.splice(index, 1)
    },
    addCategoryRow() {
      this.categories.push({
        parent: {},
        child: {},
        children: {}
      })
    },
    saveCategoryChanges() {
      // TODO: @Stan ADD action to save user changes
    }
  }
}
</script>

<style lang="scss" scoped></style>
